export const MENU_STATE = {
    ASSORTMENT: "categories",
    SITECORE: "sitecore",
    PROMOTIONS: "promotions",
    START: "start",
    MYSTORE: "mystore",
    MYADDRESSES: "myaddresses"
} as const;

export default MENU_STATE;
